import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { AuthService } from '../../auth/services/auth.service';
import { User } from '../../auth/models/user.interface';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink, ButtonModule, RouterModule],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  providers: [AuthService]
})
export class MainLayoutComponent {
  
  public navbarTitle = 'Access Code';
  user: any;
  constructor(private authService: AuthService, private router: Router) {
    this.authService.getIsAuthenticated().subscribe(isAuth => {
      console.log('---- Authentication state:' + Date.now(), isAuth);
    });
    
    this.authService.getCurrentUser().subscribe(user => {
      console.log('---- Current user:' + Date.now(), user);
      this.user = user;
    });
  }
  
  logout() {
    this.authService.signOut()
  }
}
